import type { WidgetVariant } from "@/types";
import { getWidgetOpenEvent } from "@/constants/widget-events";
import { matchTriggerButton } from "@/utils/button-manager";
import { BaseButtonService } from "./base-button.service";

export class CustomButtonService extends BaseButtonService {
  private readonly variant: WidgetVariant;
  private delegatedHandler: ((event: Event) => void) | null = null;

  constructor(variant: WidgetVariant = "on-site") {
    super();
    this.variant = variant;
  }

  initialize(): void {
    if (this.delegatedHandler) return;

    const openEvent = getWidgetOpenEvent(this.variant);
    const handler = (event: Event) => {
      const trigger = matchTriggerButton(event.target, this.variant);
      if (!trigger) return;

      window.dispatchEvent(new CustomEvent(openEvent));

      if (trigger.tagName === "A") {
        const href = trigger.getAttribute("href");
        if (href && href !== "#" && !href.startsWith("javascript:")) {
          event.preventDefault();
        }
      }
    };

    document.addEventListener("click", handler);
    this.delegatedHandler = handler;
  }

  destroy(): void {
    if (this.delegatedHandler) {
      document.removeEventListener("click", this.delegatedHandler);
      this.delegatedHandler = null;
    }
    super.destroy();
  }
}
